"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignOrder = void 0;
const sendEmail_1 = require("../sendEmail");
const addOrderLog_1 = require("./addOrderLog");
const helpers_1 = require("../../helpers");
const assignOrder = async (order_id, assigned_to, send_email, note, supabase) => {
    // Update the order assigned_to field
    await supabase
        .from("orders")
        .update({
        assigned_to: assigned_to.id,
    })
        .eq("id", order_id);
    if (send_email) {
        const new_quote_email = {
            language_code: "en",
            template_id: helpers_1.REASSIGN_ORDER,
            data: {
                subject: `Order Re-assigned to ${assigned_to.name}`,
                assigned_to: assigned_to.name,
                message: note,
            },
            order_id: order_id,
        };
        // Send email to customer
        await (0, sendEmail_1.sendEmail)(new_quote_email);
    }
    await (0, addOrderLog_1.addOrderLog)(supabase, {
        type: "ORDER",
        order_id: order_id,
        detail: {
            type: "Order Re-assigned",
            title: `Order has been re-assigned to ${assigned_to.name}`,
            message: ``,
        },
    });
};
exports.assignOrder = assignOrder;
